export default __webpack_public_path__ + "static/media/srectr-kit-set-03.2aa1ab40.jpeg";